/* eslint-disable @reatom/unit-naming-rule */

import { reatomCreateWalletFlow as reatomCreateWalletFlowCommon } from '@root/features/wallet/create-wallet/atoms'

import { walletsManagerModelAtom } from './reatom-wallet-manager'

export const reatomCreateWalletFlow = () => {
  const model = reatomCreateWalletFlowCommon({
    onFinish: (ctx) => {
      const model = ctx.get(walletsManagerModelAtom)
      model.walletDetailsScreen(ctx, 'transactions')
    },
  })

  return {
    ...model,
  }
}

export type CreateWalletFlowModel = ReturnType<typeof reatomCreateWalletFlow>
